import { Menu, UnstyledButton, Group, Text } from "@mantine/core";
import { IconLanguage, IconChevronDown } from "@tabler/icons-react";
import { useTranslation } from "react-i18next";

import { SUPPORTED_LANGS, type Lang } from "../i18n";

const LABELS: Record<Lang, string> = {
  ro: "RO",
  en: "EN",
  ru: "RU",
};

export function LanguageSwitcher({ compact = false, compactOnPhone = false }: { compact?: boolean; /** Icon-only, 40px target below `xs`. */ compactOnPhone?: boolean }) {
  const { i18n, t } = useTranslation();
  const current = (SUPPORTED_LANGS as readonly string[]).includes(i18n.resolvedLanguage ?? "")
    ? (i18n.resolvedLanguage as Lang)
    : "ro";

  return (
    <Menu shadow="md" position="bottom-end" withinPortal>
      <Menu.Target>
        <UnstyledButton
          className={compactOnPhone ? "app-switch-phone" : undefined}
          aria-label={t("lang.label")}
          style={{
            padding: "4px 8px",
            borderRadius: 6,
            display: "inline-flex",
            alignItems: "center",
            gap: 4,
          }}
        >
          <IconLanguage size={16} />
          {!compact && <Text size="sm" visibleFrom={compactOnPhone ? "xs" : undefined}>{LABELS[current]}</Text>}
          <IconChevronDown size={12} className={compactOnPhone ? "app-switch-chev" : undefined} />
        </UnstyledButton>
      </Menu.Target>
      <Menu.Dropdown>
        <Menu.Label>{t("lang.label")}</Menu.Label>
        {SUPPORTED_LANGS.map((lng) => (
          <Menu.Item
            key={lng}
            onClick={() => void i18n.changeLanguage(lng)}
            disabled={lng === current}
          >
            <Group gap="xs">
              <Text size="sm" fw={lng === current ? 600 : 400}>
                {LABELS[lng]}
              </Text>
              <Text size="xs" c="dimmed">
                {t(`lang.${lng}`)}
              </Text>
            </Group>
          </Menu.Item>
        ))}
      </Menu.Dropdown>
    </Menu>
  );
}
